import {Component} from 'react';
import {FormError} from './form-errors';
import {RadioBox} from './radiobox';
import FormIndividu from './form-individu';

class Conjoint extends Component {
	constructor (props){
		super(props);
		this.state = {
			en_couple : this.props.enCouple ? true : null,
			conjoint : {
                age : 1,
                etudiant: false,
                chomeur_longue_duree: false,
                handicap: false,
                inapte_travail: false,
                enceinte: false,
                echelon_bourse: false,
                nationalite: 'FR',
            },
            rsa_isolement_recent:null,
			validations :[],

			showConjointForm :false,
			statut_marital :this.props.statutMarital,

		};

		 this.optionsStatutMarital = [
        	{ 
        	  id: 1,
        	  name: 'En Union  libre',
        	  value :'non_renseigne',
        	},
            {
              id: 2,
              name: 'Marié-e',
              value:'marie',
          	},
            {
              id: 3,
              name: 'Pacsé-e',
              value: 'pacse',
          	}
        ];
		
	}
	captureIsolementRecent= (newVal)=>{
		
		this.setState(()=>({rsa_isolement_recent:JSON.parse(newVal)}));
		
	}

	changeDureeSejourValide = (e)=>{
		const dureeSejourValide = e.target.checked;
        this.setState( ({conjoint})=> {
            if ( dureeSejourValide  === true) {
                conjoint.duree_possession_titre_sejour =   25;
            } else {
                conjoint.duree_possession_titre_sejour = 0;
            }
            return {conjoint:conjoint};
        });
	}
	handleChangeEnCouple = (newVal)=>{
		
		this.setState( ()=>{
			return {en_couple : JSON.parse(newVal)};
		});
	}
	
	handleChangeStatutCouple = (e) =>{
		const newVal  = e.target.value;
		this.setState( ()=>{
			return {statut_marital : newVal};
		}); 
	}

    validateQuestionCouple =(e)=>{
    	this.setState(()=>{
    		return {showConjointForm : this.state.en_couple}
    	});
        let validations = [];
    	if (this.state.en_couple === null){
    		let error = "Veuillez renseigner si vous êtes en couple.";
    		validations.push(error);
    	}

       	if (this.state.en_couple === false) {
    		let data ={
    			"famille":{
    				en_couple:false
    			},
    			"demandeur":{
    				statut_marital : "celibataire"
    			},
    			"conjoint":false
    		};
    		var validData= true;
    		if (this.props.hasEnfant ){

    			if (this.state.rsa_isolement_recent === null){
    				let error = "Veuillez renseigner depuis combien de temp vous vivez seul·e";
    				validations.push(error);
    				validData=false;
    			}
    			data.famille.rsa_isolement_recent = this.state.rsa_isolement_recent;

    		}

    		if (validData){
    			this.props.validateStep(data);
    		}
    			
    	}

    	if (validations.length > 0 ) {
    		this.setState({validations:validations})
    		return false;
    	}
    	return true;
    }

    validateConjoint = (newData)=>{
		this.setState(()=>{
			return {conjoint:newData}
		},()=>{

        	let data = {
        		"conjoint" : this.state.conjoint,
        		"famille": {
        			en_couple : true
        		}

        	};
        	data.conjoint.role ="conjoint";
        	if (this.state.statut_marital) {
        		data.demandeur = {
        			statut_marital : this.state.statut_marital,
        		}
        	}

        	delete data.conjoint.situations;

    		this.props.validateStep(data);
    	});
    	
    }

    questionEncouple = () => {
		return <>
			<div className="question">
	            <div className="question_couple">
					
					<RadioBox 
						name="en_couple"
						options={{"En couple":true, "Seul":false}}
						handler={this.handleChangeEnCouple}
						defaultValue={this.state.en_couple}
					><h3> Vivez-vous seul(e) ou en couple ?</h3></RadioBox>
					
			    </div>		
			</div>
			{ 
				( this.state.en_couple) ?
				<div className ="question statut-couple">
					<h3><label> Quel est le statut de votre couple ?</label><br/></h3>
					<select onChange={this.handleChangeStatutCouple} defaultValue={this.state.statut_marital}>
						{ this.optionsStatutMarital.map ( (statut) => (
							 <option value={statut.value}>{statut.name}</option>
							))}
					</select>
				</div>
				: (this.state.en_couple===false && this.props.hasEnfant) ?
				<div className="question parent-isole">
					<RadioBox
						name="rsa_isolement_recent"
						options={{
							"Moins de 18 mois":true,
							"Plus de 18 mois":false
						}}
						defaultValue={this.state.rsa_isolement_recent}
						handler={this.captureIsolementRecent}
						><h3>Depuis combien de temps vivez-vous seul·e ?</h3></RadioBox>
				</div> :''
			}
			<div className="error-container">
				<FormError errors={this.state.validations}/>
			</div>
			<button onClick={this.validateQuestionCouple}>Valider</button>
			<div className="button-container previous">
						<button onClick={this.restart}> Recommencer </button>
			</div>
		</>
	}

	formConjoint = ()=> {
		return <FormIndividu saveData={this.validateConjoint} />;
	}

	restart = ()=> {
		this.props.restart();
	}

	render (){
		return <div className="step-inner-container">
		<p className="step-title"><strong>Conjoint(e)</strong></p> 
			{
				(this.state.showConjointForm ) ?
				  (this.formConjoint()) :
				  (this.questionEncouple())

			}

		</div>

	}
}

export default Conjoint;
